import { AtlasLanguageProvider } from '@globalmed/atlas-ui';
import { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useSearchParams } from 'react-router-dom';
import { Loader } from '@/components/Loader';
import { ToastController } from '@/components/ToastController';
import { useLanguageContext } from '@/features/LanguageContext';
import { useInstitutionsStore } from '@/stores/institutions';
import { useWhitelabelStore } from '@/stores/whitelabel';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';
import { popupSoundPlayer } from '@/utils/soundPlayer';

export const GlobalLayout = () => {
  const { ready } = useTranslation();
  const { language } = useLanguageContext();
  const { currentInstitution } = useInstitutionsStore((state) => ({
    currentInstitution: state.currentInstitution,
  }));
  const { currentWhitelabel } = useWhitelabelStore((state) => ({
    currentWhitelabel: state.currentWhitelabel,
  }));

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (currentInstitution) {
      document.title = currentInstitution?.whitelabel?.enabled
        ? (currentInstitution?.whitelabel?.productName ?? 'eNOW')
        : 'eNOW';
    } else if (currentWhitelabel) {
      document.title = currentWhitelabel?.whitelabel?.enabled
        ? (currentWhitelabel?.whitelabel?.productName ?? 'eNOW')
        : 'eNOW';
    } else {
      document.title = 'eNOW';
    }
  }, [
    currentInstitution,
    currentInstitution?.whitelabel?.enabled,
    currentInstitution?.whitelabel?.productName,
    currentWhitelabel,
  ]);

  useEffect(() => {
    const flag = searchParams.get('openOnDemand');
    if (flag === '1' || flag === 'true') {
      localStorage.setItem(LOCAL_STORAGE_KEYS.OPEN_ON_DEMAND, '1');
    }
  }, [searchParams]);

  useEffect(() => {
    const unlockAudio = () => {
      popupSoundPlayer.unlock();
    };

    document.addEventListener('click', unlockAudio, { once: true });
    document.addEventListener('touchstart', unlockAudio, { once: true });

    return () => {
      document.removeEventListener('click', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
    };
  }, []);

  if (!ready)
    return (
      <div style={{ height: '100dvh' }}>
        <Loader />
      </div>
    );
  return (
    <AtlasLanguageProvider language={language}>
      <ToastController />
      <div style={{ height: '100dvh' }}>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </div>
    </AtlasLanguageProvider>
  );
};
